// extracted by mini-css-extract-plugin
export default {"swrHeading":"something-went-wrong_swrHeading__Vmd0a","swrParagraph":"something-went-wrong_swrParagraph__CfZzR"};